<template>
  <div class="tabbar">
    <div>
      <div class="tabbar-item" @click="changeActiveStatus('1')">
        <img v-if="tabbarType == '1'" src="../assets/76.png" alt="" />
        <img v-else src="../assets/71.png" alt="" />
        <p :class="tabbarType == '1' ? 'tab-active' : ''">{{ $t("tabbar.index") }}</p>
      </div>
      <div class="tabbar-item" @click="changeActiveStatus('2')">
        <img v-if="tabbarType == '2'" src="../assets/72.png" alt="" />
        <img v-else src="../assets/72.png" alt="" />
        <p :class="tabbarType == '2' ? 'tab-active' : ''">{{ $t("tabbar.activity") }}</p>
      </div>
      <div class="tabbar-item" @click="changeActiveStatus('3')">
        <img v-if="tabbarType == '3'" src="../assets/78.png" alt="" />
        <img v-else src="../assets/73.png" alt="" />
        <p :class="tabbarType == '3' ? 'tab-active' : ''">{{ $t("tabbar.to_promote") }}</p>
      </div>
      <div class="tabbar-item" @click="changeActiveStatus('4')">
        <img v-if="tabbarType == '4'" src="../assets/79.png" alt="" />
        <img v-else src="../assets/74.png" alt="" />
        <p :class="tabbarType == '4' ? 'tab-active' : ''">{{ $t("tabbar.help") }}</p>
      </div>
      <div class="tabbar-item" @click="changeActiveStatus('5')">
        <img v-if="tabbarType == '5'" src="../assets/80.png" alt="" />
        <img v-else src="../assets/75.png" alt="" />
        <p :class="tabbarType == '5' ? 'tab-active' : ''">{{ $t("tabbar.my") }}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    tabbarType: {
      type: String,
      default: '1'
    }
  },
  data() {
    return {}
  },
  mounted() { },
  methods: {
    changeActiveStatus(item) {
      this.$emit('changeActiveStatus', item)
    }
  }
}
</script>

<style lang="scss" scoped>
.tabbar {
  width: 100%;
  height: 3.125rem;
  background: #110E31 !important;

  >div {
    display: flex;
    justify-content: space-between;
    padding: 0 1.875rem;
  }

  .tabbar-item {
    width: 2rem;
    height: 3.125rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    >img {
      display: block;
      width: 1.5rem;
      height: 1.5rem;
    }

    .tab-active {
      color: #ffc400 !important;
    }

    >p {
      width: 3rem;
      font-size: 0.625rem;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #484848;
      padding-top: 0.125rem;
      white-space: nowrap;
      overflow: hidden;
      text-align: center;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/tabbar.vue